import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useCurrency } from "@/context/CurrencyContext";

export default function SalaryStep({ profile, saveField }) {
  const { currency: activeCurrency } = useCurrency();
  // Prefer the profile's explicit currency; fall back to the resolved active
  // currency (which is profile-derived for authenticated users). Never USD.
  const ccy = String(profile.preferred_currency || activeCurrency).toUpperCase();
  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="ob-cur-salary">Current annual salary ({ccy})</Label>
        <Input
          id="ob-cur-salary" type="number" placeholder="120000" className="mt-1.5 font-mono"
          value={profile.current_salary || ""}
          onChange={(e) => saveField({ current_salary: e.target.value })}
          data-testid="onboarding-current-salary"
        />
      </div>
      <div>
        <Label htmlFor="ob-tgt-salary">Target salary in 3-5 years ({ccy}) (optional)</Label>
        <Input
          id="ob-tgt-salary" type="number" placeholder="180000" className="mt-1.5 font-mono"
          value={profile.target_salary || ""}
          onChange={(e) => saveField({ target_salary: e.target.value })}
          data-testid="onboarding-target-salary"
        />
      </div>
    </div>
  );
}
